import { render, staticRenderFns } from "./Indicadores.vue?vue&type=template&id=00e9b6fd"
import script from "./Indicadores.vue?vue&type=script&setup=true&lang=js"
export * from "./Indicadores.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports